import React, { useEffect, useState } from "react";
import {
  getCartList,
  getRemoveProductToCartList,
} from "redux/actions/cartWishlist";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "assets/icons/outline-del.svg";
import { Link, useNavigate } from "react-router-dom";
import ReactHtmlParser from "components/Common/ReactHtmlParser";
import { getLocalStorageValue } from 'config/helper';
import useShippingLabel from 'hooks/useShippingLabel';

const ShoppingCart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [hideDropdown, setHideDropdown] = useState(false);
  const { shippingLabelLower } = useShippingLabel()

  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");

  const { productCartList, productCartDetails, cateringAndMealKitProductCartList } = useSelector(({ cartWishlist }) => cartWishlist);
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  const isShowMultipleCart = !!cateringAndMealKitProductCartList.length

  const cartTotalAmount =
    productCartList &&
    productCartList.reduce((acc, prodcut) => {
      return acc + +prodcut?.final_total - +(prodcut?.bogo_discount ?? 0);
    }, 0);

  const bogoDiscount = +productCartDetails?.bogo_discount_amount ?? 0
  const bogoDiscountLabel = productCartDetails?.bogo_discount_amount_lable ?? ""

  const isEbtProductAvailable = productCartList.some(
    (product) => product.ebt_item === "1"
  );
  const cartTotalAmountForCateringAndMealKit =
    cateringAndMealKitProductCartList &&
    cateringAndMealKitProductCartList.reduce((acc, prodcut) => {
      return acc + +prodcut?.final_total - +(prodcut?.bogo_discount ?? 0);
    }, 0);

  const totalCartProductLength = productCartList.length + cateringAndMealKitProductCartList.length

  const handleMouseEnter = () => {
    setHideDropdown(false);
  };

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: "shop",
      member_number: memberNumber,
      user_token: userToken,
      Version: "1",
      DeviceType: "web",
    };
    isUserLoggedIn && dispatch(getCartList(body));
  }, [isUserLoggedIn, storeId]); // eslint-disable-line

  const handleRemoveProductToCart = (item_id) => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      item_id,
      member_number: memberNumber,
      user_token: userToken,
      AppName: "shop",
      DeviceType: "web",
      Version: "1",
    };
    dispatch(getRemoveProductToCartList(body));
  };


  const handleRedirectOnPdpPage = product => {
    setHideDropdown(true)
    if (product.is_mealkit == "0") {
      navigate(`/product-description/${product.department_slug}/${product.slug}`);
    } else {
      navigate(
        `/catering-product-description/${product.department_slug}/${product.slug}`
      );
    }
  }
  const {
    allow_delivery = "0",
    allow_pickup = "0",
    minimum_delivery_order_amount = "0",
    minimum_pickup_order_amount = "0"
  } = productCartDetails

  let buttonDisable = false
  let minimum_order_amount_message = ""

  if (allow_delivery === "1" && minimum_delivery_order_amount < cartTotalAmount) {
    buttonDisable = true
  } else if (allow_pickup === "1" && minimum_pickup_order_amount < cartTotalAmount) {
    buttonDisable = true
  }
  else if ((allow_delivery === "1" && minimum_delivery_order_amount < cartTotalAmount) || (allow_pickup === "1" && minimum_pickup_order_amount < cartTotalAmount)) {
    buttonDisable = true
  }

  // min amount msg based on remaining amount and pickup or delivery
  if ((allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount) && (allow_pickup === "1" && minimum_pickup_order_amount > cartTotalAmount)) {
    minimum_order_amount_message = `Min: <span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span><span className="danger">✘</span> &nbsp;&nbsp;&nbsp;&nbsp; <span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  }
  else if (allow_pickup === "1" && allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount && minimum_pickup_order_amount <= cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="success">$${minimum_pickup_order_amount} (pickup)✔</span>&nbsp;&nbsp;&nbsp;&nbsp; <span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  } else if (allow_pickup === "1" && allow_delivery === "1" && minimum_pickup_order_amount > cartTotalAmount && minimum_delivery_order_amount <= cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span> <span className="danger">✘</span>&nbsp;&nbsp;&nbsp;&nbsp; <span className="success">$${minimum_delivery_order_amount} (${shippingLabelLower})✔</span>`
  }
  else if (allow_pickup === "1" && minimum_pickup_order_amount > cartTotalAmount) {
    minimum_order_amount_message = `Min: <span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span><span className="danger">✘</span>`
  } else if (allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  }

  let CheckoutRedirectURL = "";

  if (cartTotalAmount.toFixed(2) > 0) {
    CheckoutRedirectURL = "/your-cart"
  } else if (cartTotalAmountForCateringAndMealKit.toFixed(2) > 0) {
    CheckoutRedirectURL = "/your-cart/catering-meal"
  } else {
    CheckoutRedirectURL = "/search/products?s=";
  }
  return (
    <>
      <div className="info-relative" onMouseEnter={handleMouseEnter}>

        <Link to={CheckoutRedirectURL}>
          <div className="info-wrapper">
            <div>
              <i className="fa-solid fa-cart-shopping"></i>

              {totalCartProductLength !== 0 ? (
                <div className="bg-primary">
                  <span>{totalCartProductLength}</span>
                </div>
              ) : (
                ""
              )}
            </div>
            <div>
              <span>My Cart</span>
              <h6>{cartTotalAmount ? `$ ${cartTotalAmount.toFixed(2)}` : ""}</h6>
            </div>
          </div>
        </Link>

        <div
          className={
            hideDropdown
              ? "shopping-cart-dropdown-hide"
              : "shopping-cart-dropdown"
          }
        >
          {isShowMultipleCart ? <div className="shopping-cart-border">

            <div className="multiple-cart-list-view-design-align">

              {productCartList && !!productCartList.length && (
                <div className="multiple-cart">
                  <div className="multiple-cart-info">
                    <p>{clientId == 347 ? "Donations" : "Grocery"}</p>
                    <div className="multiple-cart-info-wrapper">

                      <div>
                        <i className="fa-solid fa-cart-shopping"></i>

                        {productCartList.length !== 0 ? (
                          <div className="bg-primary">
                            <span>{productCartList.length}</span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                    </div>
                  </div>

                  <div className="total-payment-info">
                    <p>Total</p>
                    <h4>
                      {cartTotalAmount
                        ? `$ ${cartTotalAmount.toFixed(2)}`
                        : "$ 0"}
                    </h4>
                  </div>
                  {/* <p style={{paddingLeft: '30px'}}>
                    {minimum_order_amount_message || ""}
                  </p> */}
                  {!isEbtProductAvailable && <div>
                    <ReactHtmlParser
                      htmlString={minimum_order_amount_message || ""}
                    />
                  </div>}
                  <div className="multiple-view-checkout-cart">
                    <Link to="/your-cart" className="yourcart-button">
                      <button onClick={() => setHideDropdown(true)}>
                        View cart
                      </button>
                    </Link>
                    {isEbtProductAvailable ? <Link to="/checkout" className="checkout-button">
                      <button onClick={() => setHideDropdown(true)}>
                        Checkout
                      </button>
                    </Link> : !buttonDisable ? (
                      <div className="checkout-button">
                        <button className="disable-btn">
                          Checkout
                        </button>
                      </div>
                    ) : (
                      <Link to="/checkout" className="checkout-button">
                        <button onClick={() => setHideDropdown(true)}>
                          Checkout
                        </button>
                      </Link>
                    )}
                  </div>
                </div>
              )}

              {/* catering and meal kit */}

              {cateringAndMealKitProductCartList && !!cateringAndMealKitProductCartList.length && (
                <div className="multiple-cart">
                  <div className="multiple-cart-info">
                    <p>{clientId == 347 ? "Events" : "Catering & Meals"}</p>
                    <div className="multiple-cart-info-wrapper">

                      <div>
                        <i className="fa-solid fa-cart-shopping"></i>

                        {cateringAndMealKitProductCartList.length !== 0 ? (
                          <div className="bg-primary">
                            <span>{cateringAndMealKitProductCartList.length}</span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                    </div>
                  </div>

                  <div className="total-payment-info">
                    <p>Total</p>
                    <h4>
                      {cartTotalAmountForCateringAndMealKit
                        ? `$ ${cartTotalAmountForCateringAndMealKit.toFixed(2)}`
                        : "$ 0"}
                    </h4>
                  </div>

                  <div className="multiple-view-checkout-cart">
                    <Link to="/your-cart/catering-meal" className="yourcart-button">
                      <button onClick={() => setHideDropdown(true)}>
                        View cart
                      </button>
                    </Link>
                    <Link to="/checkout/catering-meal" className="checkout-button">
                      <button onClick={() => setHideDropdown(true)}>
                        Checkout
                      </button>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div> : <div className="shopping-cart-border">
            <div className="list-view-design-align">
              {productCartList.length === 0 ? (
                <div className="cart-empty-message">
                  <h2>Cart is empty</h2>
                </div>
              ) : (
                ""
              )}

              {productCartList.map((product = {}) => {
                const {
                  image,
                  name,
                  qty,
                  product_id,
                  item_id,
                  row_total,
                } = product ?? {}

                let { bogo_discount = 0, promotion_bogo_offer_title = "" } = product ?? {};
                bogo_discount = Number(bogo_discount) || 0;

                return (
                  <div className="cart-grid" key={product_id}>
                    <div className="cart-grid-items">
                      <div className="product-image-show">
                        <img src={image} alt="CartProductImage" />
                      </div>
                    </div>
                    <div className="cart-grid-items">
                      <h3 onClick={() => handleRedirectOnPdpPage(product)}>{name}</h3>
                      <p>
                        <span className="qty-tag">Qty: {qty}</span>
                      </p>
                       {product.ebt_item > 0 ? (
                        <div className="ebt-image">
                          <img src="https://aogecom.s3.amazonaws.com/cms_new_pages/306/new_pages_306_1746705709.png" alt="Ebt Image" />
                        </div>
                      ) : null}
                      {bogo_discount > 0 && promotion_bogo_offer_title ? (
                        <div className="bogo-discount-container">
                          <span>{promotion_bogo_offer_title}</span>
                        </div>
                      ) : null}
                    </div>
                    <div className="cart-grid-items">
                      {bogo_discount ? <span className="final-price-tag">${(row_total - bogo_discount).toFixed(2)}</span> : null}
                      <span className={`final-price-tag ${bogo_discount ? "bogo-discount-applied" : ""}`}>{row_total}</span>
                    </div>
                    <div className="cart-grid-items">
                      <img
                        src={CloseIcon}
                        alt="CloseIcon"
                        onClick={() => handleRemoveProductToCart(item_id)}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            {productCartList && !!productCartList.length && (
              <>
                {bogoDiscount > 0 && <div className="total-payment">
                  <p>{bogoDiscountLabel}: </p>
                  <h4 className='bogo-discount'>
                    {bogoDiscount
                      ? `-$${bogoDiscount.toFixed(2)}`
                      : "$ 0"}
                  </h4>
                </div>}
                <div className="total-payment">
                  <p>Subtotal: </p>
                  <h4>
                    {cartTotalAmount
                      ? `$ ${cartTotalAmount.toFixed(2)}`
                      : "$ 0"}
                  </h4>
                </div>
                {/* <p style={{paddingLeft: '30px'}}>
                    {minimum_order_amount_message || ""}
                  </p> */}
                {!isEbtProductAvailable && <div>
                  <ReactHtmlParser
                    htmlString={minimum_order_amount_message || ""}
                  />
                </div>}

                <div className="view-checkout-cart">
                  <Link to="/your-cart" className="yourcart-button">
                    <button onClick={() => setHideDropdown(true)}>
                      View cart
                    </button>
                  </Link>
                  {isEbtProductAvailable ? <Link to="/checkout" className="checkout-button">
                    <button onClick={() => setHideDropdown(true)}>
                      Checkout
                    </button>
                  </Link> : !buttonDisable ? (
                    <div className="checkout-button">
                      <button className="disable-btn">
                        Checkout
                      </button>
                    </div>
                  ) : (
                    <Link to="/checkout" className="checkout-button">
                      <button onClick={() => setHideDropdown(true)}>
                        Checkout
                      </button>
                    </Link>
                  )}
                </div>
              </>
            )}
          </div>}

        </div>
      </div>
    </>
  );
};

export default ShoppingCart;